import { FormFieldProps } from '../../form/FormTypes';
import { FormRow as FormRowProps } from '../../../../component-props';
import { buildField } from '../../form/FormFieldFactory';
import { LayoutContainer } from '@greystar/designsystem';

export const FormRow = (props: FormRowProps & FormFieldProps): JSX.Element => (
  <div key={props.id}>
    <LayoutContainer flexDirection="row" flexWrap="wrap" gap="lg">
      {props.fields.rowFields.map((field) => buildField({ field, ...props }))}
    </LayoutContainer>
  </div>
);
